require('./kovHeaderBar.scss');

let m = angular.module( 'kovHeaderBarModule', [] );
m.component('kovHeaderBar', require('./kovHeaderBar.js'));

m.component('kovSimpleHeader', require('./kovSimpleHeader.js'));

module.exports = 'kovHeaderBarModule';